<script>
  import { youtube_parser } from '../../../components/Utils.svelte'
  export let item
  export let base
  let placeholder = 'S9HdPi9Ikhk'
</script>

<div class="row no-gutters">

  {#if item.video}
    <div class="responsive-container">
      <iframe
        title="video"
        class="responsive-iframe"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/{youtube_parser(item.video)}"
        frameborder="0"
        allowfullscreen />
    </div>
  {:else}
    <div class="responsive-container">
      <iframe
        title="video"
        class="responsive-iframe"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/{placeholder}"
        frameborder="0"
        allowfullscreen />
    </div>
  {/if}

</div>
